<template>
  <div class="uikit-form">
    <div class="layout__subtitle">Кнопки</div>

    <div class="uikit-form__buttons">
      <div class="uikit-form__row">
        <c-button responsive label="Управление фильтрами" icon="filter" />

        <c-button
          responsive
          label="Новый расчет"
          :icon="{
            icon: 'plus',
            color: 'white',
          }"
          color="blue"
        />

        <c-button responsive icon="cog" label="Настроить столбцы" />

        <c-button
          responsive
          label="Новый сорудник"
          :icon="{
            icon: 'plus',
            color: 'blue',
          }"
        />
      </div>

      <div class="uikit-form__row">
        <c-button-2 size="small" :responsive="true" icon="back" type="with-icon" label="К списку сотрудников" />
      </div>

      <div class="uikit-form__row">
        <c-button
          :icon="{
            icon: 'excel',
            color: 'green',
          }"
          label="Выгрузить в Excel"
          responsive
        />

        <c-button
          :icon="{
            icon: 'google',
            color: 'green',
          }"
          label="Выгрузить в Google таблицы"
          responsive
        />

        <c-button
          :icon="{
            icon: 'print',
          }"
          label="Распечатать расчетный лист"
          responsive
        />

        <c-button
          responsive
          label="Сбросить фильтры столбцов"
          :icon="{ color: 'pink', icon: 'filter-drop' }"
          type="with-icon"
        />
      </div>

      <div class="uikit-form__row">
        <div class="d-flex align-items-center">
          <c-button
            :icon="{
              icon: 'bookmark',
              activeColor: 'white',
            }"
            :tooltip="{
              text: 'Добавить в закладки',
              activeText: 'Убрать из закладок',
            }"
            active-color="blue"
            :active="buttons.bookmark"
            @click="buttons.bookmark = !buttons.bookmark"
          />

          <c-button-2 size="small" icon="comment" />

          <c-button-2
            size="small"
            icon="edit"
            :tooltip="{
              text: 'Настройки сотрудника',
            }"
          />
        </div>
      </div>

      <div class="uikit-form__row">
        <c-button size="large" class="m-table-settings__actions-item" label="Сбросить" />

        <c-button class="m-table-settings__actions-item" label="Применить" color="blue" size="large" />
      </div>

      <div class="uikit-form__row">
        <c-button-2 size="small" :responsive="true" icon="back" type="with-icon" label="К списку сотрудников" :pending="true" />
      </div>

      <div class="uikit-form__row">
        <div class="d-flex align-items-center">
          <c-button icon="info" tooltip="Какая-то информация" size="small" no-border />

          <c-button-2 size="iconic" icon="edit" />

          <c-button-2 size="iconic" :icon="{ icon: 'trash', color: 'secondary' }" />

          <c-button-2 size="iconic" icon="arrows-constructor" />

          <c-button
            :icon="{
              icon: 'filter-column',
              activeColor: 'blue',
            }"
            :tooltip="{
              text: 'Применить фильтр',
              activeText: 'Изменить фильтр',
            }"
            no-border
            size="small"
            :active="buttons.filter"
            @click="buttons.filter = !buttons.filter"
          />

          <c-button-2
            icon="chart"
            :active="!buttons.chart"
            :responsive="true"
            :label="buttons.chart ? 'Скрыть графики' : 'Показать графики'"
            size="small"
            @click="buttons.chart = !buttons.chart"
          />

          <c-button-2 size="small" :responsive="true" icon="download" type="with-icon" label="Скачать одним архивом" />
        </div>
      </div>

      <div class="uikit-form__row">
        <c-button-dropdown
          icon="arrow"
          :dropdown-with-icon="true"
          dropdown-icon="plus"
          dropdown-icon-color="blue"
          type="dropdown"
          label="Добавить"
          :dropdown="{
            position: 'left',
            items: [{ label: 'Группу' }, { label: 'Категорию' }],
          }"
        />
      </div>
    </div>

    <div class="layout__hr"></div>
  </div>
</template>

<script>
import Button from "@/components/controls/button";
import Button2 from "@/components/controls2/Button";
import ButtonDropdown from "@/components/controls/button-dropdown";

export default {
  name: "uikit-buttons",

  components: {
    "c-button": Button,
    "c-button-2": Button2,
    "c-button-dropdown": ButtonDropdown,
  },

  data() {
    return {
      buttons: {
        bookmark: false,
        filter: false,
        chart: false,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.uikit-form {
  &__row {
    & + .uikit-form__row {
      margin-top: 20px;
    }
  }
  &__buttons {
    .c-button {
      margin-left: 20px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
